/**
 * address 申卡个人信息1拆分-页面2 家庭地址
 * 与 card-address 隔离,行为一致但互不影响
 * 从 manhattan-baldr-webapp/store/personal-info-address/index.ts 搬运并适配
 */
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

const PersonalInfoAddressStore = defineStore({
  state: () => ({
    ocrConfirmAddressFormFields: {
      ocrPostCode: '',
      ocrPostCodeId: '',
      ocrAddress: '',
      supplement: '',
    },
    isCheckedDetail: false,
    page: '',
  }),
  mutations: {
    updateAddressFormFields(state, data: Record<string, string>) {
      data &&
        Object.assign(
          state.ocrConfirmAddressFormFields,
          data
        )
    },
    update(state, data: Record<string, any>) {
      data && Object.assign(state, data)
    },
    reset(state) {
      const fields = state.ocrConfirmAddressFormFields
      type FieldKey = keyof typeof fields
      Object.keys(fields).forEach((key) => {
        fields[key as FieldKey] = ''
      })
      state.isCheckedDetail = false
      state.page = ''
    },
  },
  getters: {
    formattedApiParams(state) {
      return {
        ocrPostCode:
          state.ocrConfirmAddressFormFields.ocrPostCode,
        ocrPostCodeId:
          state.ocrConfirmAddressFormFields.ocrPostCodeId,
        ocrAddress:
          state.ocrConfirmAddressFormFields.ocrAddress,
      }
    },
  },
})

export default PersonalInfoAddressStore
export type IPersonalInfoAddressStore = IStoreState<
  typeof PersonalInfoAddressStore.state
>
